import { render, staticRenderFns } from "./InTransit.vue?vue&type=template&id=bf52a4fc"
import script from "./InTransit.vue?vue&type=script&lang=js"
export * from "./InTransit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports